import React from 'react'
import { CloseSVG } from '../../Icons/Basic'
import { MessageConfig, MessageType } from './Message.constants'
import {
  MessageContainer,
  MessageCTAButton,
  MessageContent,
  MessageText,
  MessageIcon,
  MessageCloseButton,
} from './Message.styles'
import { MessageCTA } from './Message.types'

export const Message = ({
  messageType,
  messageText,
  ctaButton,
  size = 'small',
  padding = '16px',
  onDismiss,
}: {
  messageType: MessageType
  messageText: string
  ctaButton?: MessageCTA
  size?: 'small' | 'medium'
  padding?: string
  onDismiss?: () => void
}): JSX.Element => {
  const { icon, backgroundColor, borderColor } = MessageConfig[messageType]
  return (
    <MessageContainer
      backgroundColor={backgroundColor}
      borderColor={borderColor}
      padding={padding}
    >
      <MessageContent>
        <MessageIcon $size={size}>{icon}</MessageIcon>
        <MessageText $size={size}>{messageText}</MessageText>
      </MessageContent>
      {ctaButton && (
        <MessageCTAButton
          onClick={ctaButton.onClick}
          $withMargin={ctaButton.withMargin}
          $size={size}
        >
          {ctaButton.text}
        </MessageCTAButton>
      )}
      {onDismiss && (
        <MessageCloseButton onClick={onDismiss} $size={size}>
          <CloseSVG />
        </MessageCloseButton>
      )}
    </MessageContainer>
  )
}
